import { render, staticRenderFns } from "./StopList.vue?vue&type=template&id=4656d8aa&scoped=true&"
import script from "./StopList.vue?vue&type=script&lang=js&"
export * from "./StopList.vue?vue&type=script&lang=js&"
import style0 from "./StopList.vue?vue&type=style&index=0&id=4656d8aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4656d8aa",
  null
  
)

export default component.exports